/* eslint-disable no-console */
/* eslint-disable no-alert */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  StripeProvider,
  Elements,
  injectStripe
} from 'react-stripe-elements';
import moment from 'utils/moment';
import SectionHeader from '../../../components/sectionHeader';
import HeaderBack from '../../../components/headerBack/HeaderBack';
import icon from '../../../icons/invoice.png';
import styles from './InvoicePayment.module.scss';
import Loading from '../../../components/loading';
import { fetchInvoiceDetail, doPayment, invoiceGetSchema } from '../redux/actions';
import CustomFields from '../../../components/customFields/CustomFields';
import { getStripeKey } from '../../../utils/helpers';

const createOptions = () => ({
    style: {
      base: {
        fontSize: '16px',
        color: '#424770',
        fontFamily: 'Open Sans, sans-serif',
        letterSpacing: '0.025em',
        border: '1px solid red',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#c23d4b'
      }
    }
  });

class _CardForm extends Component {
  state = {
    card_error_msg: '',
    card_expiry_error_msg: '',
    card_cvv_error_msg: '',
    answers: {},
    invoiceSchema: [],
    conditionalFields: {},
    showFormErrors: false,
    fieldErrors: {},
    enableAutoPay: false
  };

  static getDerivedStateFromProps(props, state) {
    const { paymentSchema } = props;
    if (state?.invoiceSchema?.length === 0 && paymentSchema?.schema?.fields?.length > 0) {
      let requiredMap = {};
      let errors = {};
      const conditionalFields = {};
      paymentSchema.schema.fields.forEach((detailField) => {
        requiredMap = {
          ...requiredMap,
          [detailField.id]: detailField.type === 'signature' ? false : detailField.required
        };
        if (!detailField?.conditional) {
          errors = {
            ...errors,
            [detailField.id]: detailField?.required
          };
        } else {
          conditionalFields[
            detailField?.conditional_field?.key
          ] = detailField;
        }
      });
      return {
        ...state,
        invoiceSchema: paymentSchema?.schema?.fields,
        requiredMap,
        fieldErrors: errors,
        conditionalFields
      };
    }
    return state;
  }

  componentDidMount() {
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  handleSubmit = (ev) => {
    const { fieldErrors, answers, enableAutoPay } = this.state;
    ev.preventDefault();
    const noErrors = Object.keys(fieldErrors).every(
      k => fieldErrors[k] === false
    );
    if (noErrors) {
      if (this.props.stripe) {
        this.props.stripe.createToken().then((payload) => {
          if (payload?.tokenDetails?.error && Object.keys(payload?.tokenDetails?.error)?.length > 0) return;
            this.props.enableLoadingStatus();
            this.props.doPayment(payload, answers, enableAutoPay);
        });
      } else {
        console.log("Stripe.js hasn't loaded yet.");
      }
    } else {
      console.log("Stripe.js hasn't loaded yet.");
      this.setState({
        showFormErrors: true
      });
    }
  };

  handleChange = (change, value) => {
    if (change.elementType === 'cardNumber' && !change.complete) {
      this.setState({
        card_error_msg: 'Please enter card number.'
      });
    } else if (change.elementType === 'cardNumber' && change.complete) {
      this.setState({
        card_error_msg: ''
      });
    }
    if (change.elementType === 'cardExpiry' && !change.complete) {
      this.setState({
        card_expiry_error_msg: 'Please enter card expiry date.'
      });
    } else if (change.elementType === 'cardExpiry' && change.complete) {
      this.setState({
        card_expiry_error_msg: ''
      });
    }
    if (change.elementType === 'cardCvc' && !change.complete) {
      this.setState({
        card_cvv_error_msg: 'Please enter card cvv.'
      });
    } else if (change.elementType === 'cardCvc' && change.complete) {
      this.setState({
        card_cvv_error_msg: ''
      });
    }
    if (value==='enableAutoPay') {
      this.setState({
        enableAutoPay: change.target.checked
      });
    }
  };

  handleCutomAnswerChanged = (section, answer, fieldId) => {
    const { conditionalFields } = this.state;
    if (conditionalFields?.[fieldId]) {
      const conditionValues = conditionalFields[fieldId]?.conditional_values;
      let fieldValue = answer;
      if (typeof fieldValue === 'boolean') fieldValue = fieldValue.toString();
      const enabelCondition = conditionValues.filter(
        value => fieldValue.includes(value?.value) === true
      ).length > 0;
      if (conditionalFields?.[fieldId].required) {
        this.handleFieldErrorChanged(
          conditionalFields[fieldId].id,
          enabelCondition
        );
      }
      this.setState(prevState => ({
        [section]: {
          ...prevState[section],
          [fieldId]: answer,
          [conditionalFields[fieldId].id]: ''
        }
      }));
    } else {
      this.setState(prevState => ({
        [section]: {
          ...prevState[section],
          [fieldId]: answer
        }
      }));
    }
  };

  handleFieldErrorChanged = (id, value) => {
    this.setState(prevState => ({
      fieldErrors: {
        ...prevState.fieldErrors,
        [id]: value
      }
    }));
  };

  render() {
    const { showFormErrors, invoiceSchema, answers, requiredMap, enableAutoPay } =this.state;
    const { invoiceDetail } = this.props;
    return (
      <form onSubmit={this.handleSubmit}>
        <div className={styles.inputDetails}>
          <div className={styles.detailField} style={{ padding: '5px 15px' }}>
            <FormattedMessage
              id={'invoice.payment.card_number'}
              defaultMessage={'Card Number'}
            />
            <CardNumberElement
              onChange={this.handleChange}
              {...createOptions()}
              className={styles.StripeElement}
            />
            <span style={{ color: 'red' }}>{this.state.card_error_msg}</span>
          </div>
          <div className={styles.detailField} style={{ padding: '5px 15px' }}>
            <FormattedMessage
              id={'invoice.payment.card_expiry_date'}
              defaultMessage={'Expiration date'}
            />
            <CardExpiryElement
              onChange={this.handleChange}
              {...createOptions()}
              className={styles.StripeElement}
            />
            <span style={{ color: 'red' }}>
              {this.state.card_expiry_error_msg}
            </span>
          </div>
          <div className={styles.detailField} style={{ padding: '5px 15px' }}>
            <FormattedMessage
              id={'invoice.payment.card_cvv'}
              defaultMessage={'CVV'}
            />
            <CardCVCElement onChange={this.handleChange} {...createOptions()} className={styles.StripeElement} />
            <span style={{ color: 'red' }}>
              {this.state.card_cvv_error_msg}
            </span>
          </div>
          {invoiceDetail?.recurring &&(
            <div className={styles.detailField} style={{ padding: '5px 15px' }}>
            <span className={styles.checkbox_title}>
            <FormattedMessage
              id="invoice.detail.auto.pay"
              defaultMessage="Save this Card for Automatic Payments"
              />
            </span>
            <input
              className={styles.checkbox}
              type="checkbox"
              onChange={e => this.handleChange(e, 'enableAutoPay')}
              checked={enableAutoPay}
              value={enableAutoPay}
              style={{ marginLeft: '15px' }}
            />
            </div>
          )}

          <div className={`${styles.detailField} ${styles.fieldPadding}`}>
            <CustomFields
              handleAnswerChanged={(a, b) => this.handleCutomAnswerChanged('answers', a, b)}
              handleFieldErrorChanged={(fieldId, value) => this.handleFieldErrorChanged(
                fieldId,
                value
              )}
              showFormErrors={showFormErrors}
              requiredMap={requiredMap}
              fields={invoiceSchema}
              answers={answers}
              fromForms
            />
          </div>
          <div className={styles.detailField} style={{ padding: '5px 15px' }}>
            <button className={styles.pay_button}>Pay</button>
          </div>
        </div>
      </form>
    );
  }
}

const CardForm = injectStripe(_CardForm);

// eslint-disable-next-line react/no-multi-comp
class InvoicePayment extends Component {
  state = {
    info: {
      customer: {}
    },
    items: [],
    addCustomerPopup: false,
    showFormErrors: false,
    fieldErrors: {
      payment_due: true,
      invoice_date: true,
      customer: true
    },
    itemErrors: [],
    customerFilter: '',
    itemFilter: false,
    loadingStatus: false
  };

  static getDerivedStateFromProps(props, state) {
    const { history } = props;
    const paramId = props.match.params.id;
    if (
      paramId
      && state.info
      && Object.keys(state.info).length <= 1
      && props.invoiceDetail
      && Object.keys(props.invoiceDetail).length
    ) {
      const invoice = props.invoiceDetail;
      return {
        ...state,
        info: {
          customer: invoice.customer,
          summary: invoice.summary,
          description: invoice.description,
          po_so_number: invoice.po_so_number,
          payment_due: moment(invoice.payment_due).format(),
          invoice_date: moment(invoice.invoice_date).format()
        }
      };
    }
    if (
      props.updatePaymentAction && props.updatePaymentAction.success === true
    ) {
      history.push('/invoice');
    } if (
      props.updatePaymentAction && props.updatePaymentAction.error === true
    ) {
      alert('Payment failed!');
      return {
        ...state,
        loadingStatus: props.updatePaymentAction.loading
      };
    }
    return state;
  }

  componentDidMount() {
    const {
      actionFetchInvoice, actioninvoiceGetSchema,
      match: {
        params: { id }
      }
    } = this.props;
    if (id) actionFetchInvoice(id);
    actioninvoiceGetSchema();
  }

  doPayment = (tokenDetails, answersInfo, enableAutoPay) => {
    const { actionDoPayment, invoiceDetail } = this.props;
    const sendResponse = {};
    // this.setState({ loadingStatus: true });
    if (tokenDetails) {
      sendResponse.tokenDetails = tokenDetails;
      sendResponse.amount = this.props.location.state.amount;
      sendResponse.enableAutoPay = enableAutoPay;
      if (answersInfo && Object.keys(answersInfo)?.length > 0) {
        sendResponse.other_info = {
          'payment_response': answersInfo
        };
      }
    }
    actionDoPayment(invoiceDetail.id, sendResponse);
  };

  render() {
    const { location, actioninvoiceGetSchema, paymentSchema, invoiceDetail, profile } = this.props;
    const { loadingStatus } = this.state;
    const stripeKey = getStripeKey(profile?.portal_airport?.airport_settings);

    return (
      <>
        <div className={styles.sectionWrapper}>
          <SectionHeader
            icon={icon}
            translationID="invoices_payment.title"
            defaultTitle="Pay by card"
          />
        </div>
        <div className={styles.headWrapper}>
          <HeaderBack
            translationID="inspections.new.prev"
            translationDefault="Back"
            backRoute="/invoice"
          />
        </div>
        <Loading loadingStatus={loadingStatus} />
        <div className={`container ${styles.form}`}>
          <div className={`${styles.content} ${styles.embedded}`}>
            <div className={styles.detailsWrapper}>
              <div
                className={styles.detailsSection}
                style={{ margin: '0px', paddingBottom: '0px' }}
              >
                <div className={styles.selectedCust}>
                  <div>
                    <span className={styles.billTo}>
                      <FormattedMessage
                        id="invoices_payment.title"
                        defaultMessage="Pay by card"
                      />
                    </span>
                  </div>
                </div>
                <div className={styles.fvz}>
                  <span className={styles.billTo}>
                    <NumberFormat
                      displayType="text"
                      value={
                        location.state.amount.toString().includes('.')
                          ? location.state.amount
                          : `${location.state.amount}.00`
                      }
                      thousandSeparator
                      prefix="$"
                    />
                  </span>
                </div>
              </div>
              <hr style={{ width: '837px', alignSelf: 'center' }} />
              <div className={styles.billDetailsWrapper}>
                <StripeProvider apiKey={stripeKey}>
                  <Elements>
                    <CardForm
                      doPayment={(tokenDetails, info, enableAutoPay) => this.doPayment(tokenDetails, info, enableAutoPay)}
                      paymentSchema={paymentSchema}
                      onRef={(ref) => { this.child = ref; }} actioninvoiceGetSchema={actioninvoiceGetSchema}
                      enableLoadingStatus={() => { this.setState({ loadingStatus: true }); }}
                      invoiceDetail={invoiceDetail}
                    />
                  </Elements>
                </StripeProvider>
              </div>
            </div>
          </div>
          {/* </Panel> */}
        </div>
      </>
    );
  }
}

InvoicePayment.propTypes = {
  history: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({}).isRequired,
  actionFetchInvoice: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  profile: state.auth.profile,
  invoiceDetail: state.invoice.invoiceDetail,
  updatePaymentAction: state.invoice.updatePaymentAction,
  paymentSchema: state.invoice.invoiceSchema?.payment_schema
});

const mapDispatchToProps = dispatch => ({
  actionFetchInvoice: (id) => {
    dispatch(fetchInvoiceDetail(id));
  },
  actionDoPayment: (id, data) => {
    dispatch(doPayment(id, data));
  },
  actioninvoiceGetSchema: () => {
    dispatch(invoiceGetSchema());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(InvoicePayment);
